import Marquee from "react-fast-marquee";

const words = ["Relax", "Recover", "Recharge", "Mobile Wellness", "Manchester", "Massage Therapy", "Holistic Care"];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="py-10 sm:py-14 bg-secondary/20 border-y border-border overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {words.map((w, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif text-4xl sm:text-6xl text-primary/85 px-12 sm:px-16">{w}</span>
          <span className="text-secondary text-3xl">✦</span>
        </span>
      ))}
    </Marquee>
  </div>
);
